import Transformer from './../transformer'
import AffectedTransformer from './affected'
import { fullName } from '@/transformers/jbUser'

const DEFAULT_INSURANCE_CARRIER = {
 id: 0,
 name: 'Sin Aseguradora',
}

export default class SinisterTransformer extends Transformer {

	static fetch(sinister, isCustomer) {
    const affected = sinister.affected ? AffectedTransformer.fetch(sinister.affected) : sinister.affected
    const typeOfJob = sinister.type_of_job
    const customer = sinister.customer
    const insuranceCarrier = sinister.insurance_carrier || DEFAULT_INSURANCE_CARRIER

    if (isCustomer) {
      return {
        id: sinister.id,
        customer,
        customerName: customer.name,
        customerId: customer.id,
        insuranceCarrier,
        insuranceCarrierName: insuranceCarrier.name,
        dateAssignment: sinister.date_assignment,
        dateOccurred: sinister.date_occurred,
        sinisterNumber: sinister.sinister_number,
        typeOfJob,
        typeOfJobId: typeOfJob.id,
        typeOfJobName: typeOfJob.name,
        addDate: sinister.add_date,
        affected,
        folioJB: sinister.folio_jb,
        affectedRequisitionNumber: (sinister.affected) ? affected.requisitionNumber : null,
        typeOfDamage: (sinister.affected) ? affected.typeOfDamage : null,
        sinisterDates: {
          dateOccurred: sinister.date_occurred,
          dateAssignment: sinister.date_assignment,
        },
        readyToInvoice: false,
      }
    }

    return {
      id: sinister.id,
      customer,
      customerName: customer.name,
      customerId: customer.id,
      insuranceCarrier,
      insuranceCarrierName: insuranceCarrier.name,
      insuranceCarrierId: insuranceCarrier.id,
      dateAssignment: sinister.date_assignment,
      dateOccurred: sinister.date_occurred,
      sinisterNumber: sinister.sinister_number,
      typeOfJob,
      typeOfJobId: typeOfJob.id,
      typeOfJobName: typeOfJob.name,
      userCost: sinister.users_costs.id,
      userCostName: fullName(sinister.users_costs.user),
      addDate: sinister.add_date,
      affected,
      folioJB: sinister.folio_jb,
      affectedRequisitionNumber: (sinister.affected) ? affected.requisitionNumber : null,
      typeOfDamage: (sinister.affected) ? affected.typeOfDamage : null,
      sinisterDates: {
        dateOccurred: sinister.date_occurred,
        dateAssignment: sinister.date_assignment,
      },
      readyToInvoice: false,
    }
  }
}



// WEBPACK FOOTER //
// ./src/transformers/sinister/sinister.js